export default __webpack_public_path__ + "50eea86bbe9f4dae3bc320d6c75d7b24.png";